import React, { Component } from 'react';
import { getMenuItems } from '../../../Utilities/SnsExtranetFunctions';
import { getTranslation } from '../../../Utilities/GetTranslation';

declare var globalSns;
declare var globalExtranet;

class ExtranetHome extends Component {
    constructor(props) {
        super(props);
        
        this.navigate = this.navigate.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
    }
  
    navigate(id, e) {
      this.props.onNavigate(id);
    }

    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="registration">
                        <div className="tiles text-center">
                            {
                                getMenuItems(globalExtranet.pages, null).map((x) => 
                                    x.showHome ?
                                        <a key={x.id} onClick={(e) => this.navigate(x.id, e)}>
                                            <div className="icon">
                                                <i className={"fa " + x.className} aria-hidden="true"></i>
                                            </div>
                                            <div className="title">
                                                {x.title}
                                            </div>
                                            {
                                                (x.nr ?
                                                    <div className="text">
                                                        {x.nr} {getTranslation("sns.general.extranet." + x.id + ".new")}
                                                    </div> : ""
                                                )
                                            }
                                        </a> : ""
                                )
                            }                            
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ExtranetHome;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetHome.js